import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaClientes: [],
  alugueis: [],
  boletosAvulsos: [],
  repasses: [],
  recibosRetorno: [],
  historicoRetornos: [],
}

const mutations = {

  atualizarListaClientes(state, payload) {
    state.listaClientes = payload;
  },
  atualizarAlugueis(state, payload) {
    state.alugueis = payload;
  },
  atualizarBoletosAvulsos(state, payload) {
    state.boletosAvulsos = payload;
  },
  atualizarRepasses(state, payload) {
    state.repasses = payload;
    state.repasses = state.repasses.map(item => { return { ...item, selecionado: false }});
  },
  atualizarRecibosRetorno(state, payload) {
    state.recibosRetorno = payload;
  },
  atualizarHistoricoRetornos(state, payload) {
    state.historicoRetornos = payload;
  },
  selecionarTodos(state){
    state.repasses = state.repasses.map(item => { return { ...item, selecionado: true }});
  },
  deselecionarTodos(state){
    state.repasses = state.repasses.map(item => { return { ...item, selecionado: false }});
  },
  limparAlugueis(){
    state.alugueis = []
  },
  limparBoletosAvulsos(){
    state.boletosAvulsos = []
  },
  limparRecibosRetorno() {
    state.recibosRetorno = []
  },
}

const actions = {
  limparAlugueis(context) {
    context.commit('limparAlugueis');
  },
  limparBoletosAvulsos(context) {
    context.commit('limparBoletosAvulsos');
  },
  limparRecibosRetorno(context) {
    context.commit('limparRecibosRetorno');
  },

  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaClientes', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarClientes', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  liberarRepasseEmLote(context, payload) {
    return axios.post(URLS.RECIBOS_LIBERAR_REPASSE_EM_LOTE, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('liberarRepasseEmLote', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarAlugueis(context, payload) {
    return axios.post(URLS.RECIBOS_LISTAR_BAIXAS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAlugueis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarAlugueis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarBoletosAvulsos(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_LISTAR_BAIXAS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarBoletosAvulsos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarBoletosAvulsos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarRepasses(context, payload) {
    return axios.post(URLS.RECIBOS_LISTAR_REPASSES, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarRepasses', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarRepasses', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  processarRetorno(context, payload) {
    return axios.post(URLS.ARQUIVO_RETORNO_PROCESSAR, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarRecibosRetorno', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('processarRetorno', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarHistoricoRetorno(context, payload) {
    return axios.post(URLS.ARQUIVO_RETORNO_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarHistoricoRetornos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarHistoricoRetorno', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarTodosDemonstrativos(context, payload) {
    return axios.post(URLS.RECIBOS_GERAR_DEMONSTRATIVOS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarTodosDemonstrativos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  selecionarTodos(context) {
    context.commit('selecionarTodos');
  },
  deselecionarTodos(context) {
    context.commit('deselecionarTodos');
  }
}

export default {
  state,
  mutations,
  actions
}